'use client';
import React, { useState } from 'react';
import Image from 'next/image';

const navLinks = [
{ label: 'Home', href: '#' },
{ label: 'Coffee', href: '#shop' },
{ label: 'Gifts and Gear', href: '#gear' },
{ label: 'Contact Us', href: '#contact' },
{ label: 'Where to Buy', href: '#locations' },
{ label: 'About Us', href: '#about' },
{ label: 'Manage Your Subscription', href: '#' }];

interface HeaderProps {
  allLinksTo?: string;
}

export default function Header({ allLinksTo }: HeaderProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const resolveHref = (href: string) => allLinksTo ?? href;

  return (
    <header className="site-header" role="banner">
      <div className="header-inner">
        {/* Logo */}
        <div className="logo-wrap">
          <a href={resolveHref('#')} className="logo-link">
            <Image
              src="https://coffeebythebay.com/cdn/shop/files/jpg_300x300.jpg?v=1613538718"
              alt="Bayside Coffee Co."
              width={140}
              height={140}
              style={{ maxWidth: '140px', height: 'auto' }}
              priority />
            
          </a>
        </div>

        {/* Desktop Nav */}
        <nav className="desktop-nav" aria-label="Main navigation">
          <ul className="nav-list">
            {navLinks?.map((link) =>
            <li key={link?.label}>
                <a href={resolveHref(link?.href)} className="nav-link">
                  {link?.label}
                </a>
              </li>
            )}
          </ul>
        </nav>

        {/* Icons */}
        <div className="header-icons">
          {/* Search icon */}
          <button className="icon-btn" aria-label="Search">
            <svg aria-hidden="true" focusable="false" role="presentation" className="icon-svg" viewBox="0 0 37 40" width="20" height="20">
              <path d="M35.6 36l-9.8-9.8c4.1-5.4 3.6-13.2-1.3-18.1-5.4-5.4-14.2-5.4-19.7 0-5.4 5.4-5.4 14.2 0 19.7 2.6 2.6 6.1 4.1 9.8 4.1 3 0 5.9-1 8.3-2.8l9.8 9.8c.4.4.9.6 1.4.6s1-.2 1.4-.6c.9-.9.9-2.1.1-2.9zm-20.9-8.2c-2.6 0-5.1-1-7-2.9-3.9-3.9-3.9-10.1 0-14C9.6 9 12.2 8 14.7 8s5.1 1 7 2.9c3.9 3.9 3.9 10.1 0 14-1.9 1.9-4.4 2.9-7 2.9z" fill="currentColor" />
            </svg>
            <span className="icon-label">Search</span>
          </button>
          {/* Login icon */}
          <a href={resolveHref('#')} className="icon-btn" aria-label="Log in">
            <svg aria-hidden="true" focusable="false" role="presentation" className="icon-svg" viewBox="0 0 28.33 37.68" width="20" height="20">
              <path d="M14.17 14.9a7.45 7.45 0 1 0-7.5-7.45 7.46 7.46 0 0 0 7.5 7.45zm0-10.91a3.45 3.45 0 1 1-3.5 3.46A3.46 3.46 0 0 1 14.17 4zM14.17 16.47A14.18 14.18 0 0 0 0 30.68c0 1.41.66 4 5.11 5.66a27.17 27.17 0 0 0 9.06 1.34c6.54 0 14.17-1.84 14.17-7a14.18 14.18 0 0 0-14.17-14.21zm0 17.21c-6.3 0-10.17-1.77-10.17-3a10.17 10.17 0 1 1 20.33 0c.01 1.23-3.86 3-10.16 3z" fill="currentColor" />
            </svg>
            <span className="icon-label">Log in</span>
          </a>
          {/* Cart icon */}
          <a href={resolveHref('#')} className="icon-btn" aria-label="Cart">
            <svg aria-hidden="true" focusable="false" role="presentation" className="icon-svg" viewBox="0 0 37 40" width="20" height="20">
              <path d="M36.5 34.8L33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2zM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28z" fill="currentColor" />
            </svg>
            <span className="icon-label">Cart</span>
          </a>
          {/* Mobile hamburger */}
          <button
            className="mobile-menu-btn"
            aria-label="Menu"
            onClick={() => setMobileOpen(!mobileOpen)}>
            
            {mobileOpen ?
            <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 40 40" width="22" height="22">
                <path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" fill="currentColor" />
              </svg> :

            <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 37 40" width="22" height="22">
                <path d="M33.5 25h-30c-1.1 0-2-.9-2-2s.9-2 2-2h30c1.1 0 2 .9 2 2s-.9 2-2 2zm0-11.5h-30c-1.1 0-2-.9-2-2s.9-2 2-2h30c1.1 0 2 .9 2 2s-.9 2-2 2zm0 23h-30c-1.1 0-2-.9-2-2s.9-2 2-2h30c1.1 0 2 .9 2 2s-.9 2-2 2z" fill="currentColor" />
              </svg>
            }
          </button>
        </div>
      </div>
      {/* Mobile Nav */}
      {mobileOpen &&
      <nav className="mobile-nav" role="navigation">
          <ul>
            {navLinks?.map((link) =>
          <li key={link?.label} className="mobile-nav-item">
                <a
              href={resolveHref(link?.href)}
              className="mobile-nav-link"
              onClick={() => setMobileOpen(false)}>
              
                  {link?.label}
                </a>
              </li>
          )}
          </ul>
        </nav>
      }
      <style jsx>{`
        .site-header {
          background: #fff;
          border-bottom: 1px solid #e8e9eb;
          position: sticky;
          top: 0;
          z-index: 100;
          font-family: 'Work Sans', sans-serif;
        }
        .header-inner {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 80px;
        }
        .logo-wrap {
          flex-shrink: 0;
        }
        .logo-link {
          display: block;
        }
        .desktop-nav {
          flex: 1;
          display: flex;
          justify-content: center;
        }
        .nav-list {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          gap: 0;
          justify-content: center;
        }
        .nav-link {
          display: block;
          padding: 8px 12px;
          color: #3d4246;
          text-decoration: none;
          font-size: 15px;
          font-weight: 400;
          transition: color 0.2s;
        }
        .nav-link:hover {
          color: #557b97;
        }
        .header-icons {
          display: flex;
          align-items: center;
          gap: 4px;
          flex-shrink: 0;
        }
        .icon-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          background: none;
          border: none;
          cursor: pointer;
          color: #3d4246;
          padding: 8px;
          text-decoration: none;
          font-size: 13px;
          font-family: 'Work Sans', sans-serif;
          transition: color 0.2s;
        }
        .icon-btn:hover {
          color: #557b97;
        }
        .icon-label {
          font-size: 13px;
        }
        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          cursor: pointer;
          color: #3d4246;
          padding: 8px;
        }
        .mobile-nav {
          background: #fff;
          border-top: 1px solid #e8e9eb;
        }
        .mobile-nav ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .mobile-nav-item {
          border-bottom: 1px solid #e8e9eb;
        }
        .mobile-nav-link {
          display: block;
          padding: 14px 20px;
          color: #3d4246;
          text-decoration: none;
          font-size: 15px;
          font-family: 'Work Sans', sans-serif;
        }
        .mobile-nav-link:hover {
          color: #557b97;
        }
        @media (max-width: 989px) {
          .desktop-nav {
            display: none;
          }
          .mobile-menu-btn {
            display: flex;
          }
          .icon-label {
            display: none;
          }
        }
      `}</style>
    </header>);

}